/**
 * Organization context utilities.
 * Provides org ID resolution without circular dependencies between services.
 */

/**
 * The uuid the demo seeds into `org_id` columns that are Postgres type `uuid`
 * (the TS-13.x advanced-feature tables). The app-wide demo default org id is the
 * text literal 'org_demo' (used by the ~130 text-`org_id` tables), so passing it
 * straight to a uuid column makes PostgREST 400 with `22P02 invalid input syntax
 * for type uuid: "org_demo"`. See resolveOrgId.
 */
export const DEMO_ORG_UUID = '00000000-0000-0000-0000-000000000001'

/**
 * Translate the demo's text org id ('org_demo') to the seeded uuid, for queries
 * against `uuid`-typed `org_id` columns ONLY. A real uuid (production) passes
 * through unchanged. Do NOT use this on text-`org_id` tables (audit_chain,
 * government_labor_submissions, etc.) — they legitimately hold 'org_demo'.
 */
export function resolveOrgId(orgId: string): string {
  return orgId === 'org_demo' ? DEMO_ORG_UUID : orgId
}

/** Returns the current user's organization ID from localStorage */
export function getCurrentOrganizationId(): string | null {
  try {
    return localStorage.getItem('ppm-organization-id') || null
  } catch { return null }
}

/** Returns true if the app is currently in demo mode */
export function isDemoMode(): boolean {
  try {
    const mode = localStorage.getItem('ppm-app-mode')
    return mode === null || mode === 'demo'
  } catch { return false }
}
